/* import {API_URL} from 'api/constants' */
const API_URL = `${process.env.MOKA_SERVICE_HOST}/library/v1`
export const GET_LIST_SALES_TYPE = `${API_URL}/sales-type`

export const CREATE_SALES_TYPE_SINGLE_OUTLET = `${API_URL}/sales-type`
export const CREATE_SALES_TYPE_ALL_OUTLET = `${API_URL}/sales-type/all-outlets`
export const GET_DETAIL_SALES_TYPE = (salestypeId) => `${API_URL}/sales-type/${salestypeId}`
export const UPDATE_SALES_TYPE = (salestypeId) => `${API_URL}/sales-type/${salestypeId}`
export const DELETE_SALES_TYPE = (id) => `${API_URL}/sales-type/${id}`
export const UPDATE_STATUS_SALES_TYPE = (id) => `${API_URL}/sales-type/manage-state/${id}`



// WEBPACK FOOTER //
// ./app/api/libraries/salesType/constants.js